import { render, staticRenderFns } from "./addAgent.vue?vue&type=template&id=042da8e9&scoped=true&"
import script from "./addAgent.vue?vue&type=script&lang=js&"
export * from "./addAgent.vue?vue&type=script&lang=js&"
import style0 from "./addAgent.vue?vue&type=style&index=0&id=042da8e9&prod&lang=less&"
import style1 from "./addAgent.vue?vue&type=style&index=1&id=042da8e9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042da8e9",
  null
  
)

export default component.exports